export const CASE_MODULES = {
    fax_intake: { label: "Fax intake", short: "Fax", icon: "mdi-fax" },
    order_qualification: { label: "Benefit verification", short: "BV", icon: "mdi-shield-check-outline" },
    benefits_verification: { label: "Benefits", short: "Benefits", icon: "mdi-card-account-details-outline" },
    clinical_review: { label: "Medical necessity", short: "MN", icon: "mdi-stethoscope" },
    prior_auth: { label: "Prior auth", short: "PA", icon: "mdi-file-document-check-outline" },
};
export const MODULE_ORDER = Object.keys(CASE_MODULES);
export function caseModule(key) {
    return CASE_MODULES[key] ?? { label: key, short: key, icon: "mdi-circle-small" };
}
const POLICY_CHECK = "necessity_check";
const MEDICAL_NECESSITY = "clinical_review";
const URGENCY = [
    "NEEDS_ATTENTION",
    "READY",
    "IN_PROGRESS",
    "WAITING",
    "NOT_STARTED",
    "DONE",
    "NOT_NEEDED",
    "CANCELLED",
];
function urgency(state) {
    const rank = URGENCY.indexOf(state);
    return rank === -1 ? URGENCY.length : rank;
}
/** Policy check shows as Medical necessity; with both, the MN step carries whichever of the two is more urgent. */
export function withMedicalNecessity(steps) {
    const checks = steps.filter((step) => step.moduleKey === POLICY_CHECK);
    if (!checks.length)
        return steps;
    const asReview = (step) => ({ ...step, moduleKey: MEDICAL_NECESSITY });
    if (!steps.some((step) => step.moduleKey === MEDICAL_NECESSITY)) {
        return steps.map((step) => (checks.includes(step) ? asReview(step) : step));
    }
    const urgent = checks.reduce((most, step) => (urgency(step.state) < urgency(most.state) ? step : most));
    return steps
        .filter((step) => !checks.includes(step))
        .map((step) => step.moduleKey === MEDICAL_NECESSITY && urgency(urgent.state) < urgency(step.state) ? asReview(urgent) : step);
}
